import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ErrorMessages } from '@app/shared/constants/constants';
import { RTOdrillResponse } from '@app/shared/interfaces/rto-drill';
import { environment } from '@environments/environment';
import { ToastrService } from 'ngx-toastr';
import { catchError, Observable, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class VendorListRtoDrillService {
 private baseUrl = environment.apiUrl;

  constructor(
    private http: HttpClient,
    private toasterService: ToastrService,
  ) {}

  getVendorListRtoDrill(
    employeeId: string,
    vendorId: number,
    month: number,
    year: number,
  ): Observable<RTOdrillResponse> {
    return this.http
      .get<RTOdrillResponse>(
        `${this.baseUrl}/hiring/rto-list?employeeId=${employeeId}&vendorId=${vendorId}&month=${month}&year=${year}`
      )
      .pipe(
        catchError((error) => {
          this.toasterService.error(ErrorMessages.NoDataAvailable);
          return throwError(() => error);
        })
      );
  }

}
